import { render, staticRenderFns } from "./LandingPageAddressSearch.vue?vue&type=template&id=24d872a8&scoped=true"
import script from "./LandingPageAddressSearch.vue?vue&type=script&lang=js"
export * from "./LandingPageAddressSearch.vue?vue&type=script&lang=js"
import style0 from "./LandingPageAddressSearch.vue?vue&type=style&index=0&id=24d872a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d872a8",
  null
  
)

export default component.exports